import React from 'react';
import { ResourceManager } from './components/ResourceManager';

const TestimonialsModule = () => (
  <ResourceManager
    table="testimonials"
    title="Testimonials"
    description="Highlight buyer love across landing pages."
    columns={[
      { label: 'Name', accessor: 'name' },
      { label: 'Location', accessor: 'location' },
      {
        label: 'Rating',
        accessor: 'rating',
        render: (value) => `${value || 0}/5`,
      },
    ]}
    formFields={[
      { name: 'name', label: 'Name', placeholder: 'Grace N.' },
      { name: 'location', label: 'Location', placeholder: 'Muyenga' },
      { name: 'rating', label: 'Rating (1-5)', type: 'number', placeholder: '5' },
      { name: 'message', label: 'Message', type: 'textarea' },
      { name: 'avatar_url', label: 'Avatar URL', placeholder: 'https://...' },
    ]}
    defaultValues={{
      name: '',
      location: '',
      rating: 5,
      message: '',
      avatar_url: '',
    }}
    transformBeforeSave={(payload) => ({
      ...payload,
      rating: Math.max(1, Math.min(5, Number(payload.rating) || 5)),
    })}
  />
);

export default TestimonialsModule;
